<div class="review-container">
  <h2>Please Share Your Feedback</h2>

  <!-- Close (X) Button -->
  <button mat-icon-button (click)="dialogRef.close()" class="close-button">
    <mat-icon>close</mat-icon>
  </button>

  <!-- ⭐ Star Rating -->
  <div class="stars">
    <mat-icon
      *ngFor="let star of [1, 2, 3, 4, 5]"
      class="star-icon"
      [ngClass]="{ 'selected': star <= newReview.rating }"
      (click)="setRating(star)">
      {{ star <= newReview.rating ? 'star' : 'star_border' }}
    </mat-icon>
  </div>

  <!-- Name & Review Input -->
  <mat-form-field class="full-width">
    <mat-label>Your Name</mat-label>
    <input matInput type="text" [(ngModel)]="newReview.userName" required>
  </mat-form-field>

  <mat-form-field class="full-width">
    <mat-label>Write your review...</mat-label>
    <textarea matInput [(ngModel)]="newReview.content" required></textarea>
  </mat-form-field>

  <!-- Action Buttons -->
  <div class="dialog-actions">
    <button mat-button (click)="dialogRef.close()">Cancel</button>
    <button mat-flat-button color="primary" (click)="submitReview()">Submit</button>
  </div>
</div>
